// hooks/useAnnotations.ts
import { useState, useEffect } from 'react';

export interface Annotation {
  date: string;  // YYYY-MM-DD
  icon: string;  // emoji
  note: string;  // description
}

export function useAnnotations() {
  const [annotations, setAnnotations] = useState<Annotation[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function loadAnnotations() {
      try {
        setLoading(true);
        const response = await fetch('/data/health/health-annotations.json');
        
        if (!response.ok) {
          // Return default annotation if file doesn't exist
          console.log('No annotations file found');
          setAnnotations([
            {
              date: "2025-06-27",
              icon: "🏥",
              note: "Left index finger surgery"
            }
          ]);
          return;
        }
        
        const data = await response.json();
        setAnnotations(data.annotations || []);
      } catch (err) {
        console.warn('Failed to load annotations:', err);
        setError('Failed to load annotations');
        
        // Fallback to default annotation
        setAnnotations([
          {
            date: "2025-06-27",
            icon: "🏥",
            note: "Left index finger surgery"
          }
        ]);
      } finally {
        setLoading(false);
      }
    }

    loadAnnotations();
  }, []);

  return { annotations, loading, error };
}